<template lang="pug">
main
  PmHeader
  .container
    br
    article.message.is-info
      .message-header
        p Certificado Digital
      .message-body
        .p
          strong Entidad Dueña del Certificado:
          | {{ ' ' + certificado.ownerCert }}
        .p
          strong Entidad Emisora:
          | {{ ' ' + certificado.issuerCert }}
        .p
          strong Formato de Fechas:
          | {{ ' ' + certificado.formatDate }}
        .p
          strong Fecha de Caducidad:
          | {{ ' ' + certificado.dateExpiry }}
        .p
          strong El certificado caducará en:
          | {{ ' ' + certificado.daysToExpiry + ' ' }}
          strong días
        br
        a.button.is-info(@click="showModal") Cargar
        br
    .modal(v-bind:class="{'is-active':isEditing}")
        .modal-background
        .modal-card
          header.modal-card-head
            p.modal-card-title Certificado
          section.modal-card-body
              p 
                strong Buscar archivo:
                input.input(type='file' accept='.p12' @change='onFileSelected')
              p 
                strong Contraseña:
                input.input(type='password' v-model='clave')
          footer.modal-card-foot
            button.button.is-success(@click='onUpload') Aplicar
            button.button.is-link(@click='closeModal') Cancelar
        button.modal-close.is-large(@click='closeModal')
</template>
<script>
import certificateService from '@/services/certificateService'
import PmHeader from '../components/layout/Header.vue'
import uploadFileService from '../services/uploadFileService'


export default {
  components: {
    PmHeader
  },

  data: () => ({
    certificado: {},
    isLoading: false,
    isEditing: false,
    showNotification: false,
    selectedFile: null,
    clave: ''
  }),

  mounted() {
    if (localStorage.getItem('token')) {
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },

  methods: {
    getDatosCertificado () {
      this.isLoading = true
      certificateService.certificado(localStorage.getItem('token'))
        .then(res => {      
            this.showNotification = res.length === 0
            this.certificado = res
            this.isLoading = false            
        })
        .catch(error => {
          console.log('Error')
          console.log(error)
        })
    },

    onFileSelected (event) {
      this.selectedFile = event.target.files[0]
    },

    onUpload () {
      if (this.selectedFile != null) {
        const formData = new FormData()
        formData.append('file', this.selectedFile, this.selectedFile.name)
        formData.append('password', this.clave)
        uploadFileService.upload(formData, localStorage.getItem('token'))
          .then(res => {
            // console.log(res)
            if (res.status === 200) {
              this.getDatosCertificado(localStorage.getItem('token'))
            }            
            this.isEditing = false            
          })
      }
    },

    showModal () {
      this.isEditing = true
    },

    closeModal () {
      this.isEditing = false
    }
  },

  beforeMount () {    
    this.getDatosCertificado(localStorage.getItem('token'))
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: left;
}
</style>
